/* eslint-disable max-len */
import React from 'react';

const OpPlusLogo = () => {
  return (
    <svg width="70" height="24" viewBox="0 0 70 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.8661 18.9391C19.4599 18.9391 23.1839 15.2318 23.1839 10.6586C23.1839 6.08537 19.4599 2.37805 14.8661 2.37805C10.2723 2.37805 6.54834 6.08537 6.54834 10.6586C6.54834 15.2318 10.2723 18.9391 14.8661 18.9391Z"
        fill="#F1605D"
      />
      <path
        d="M6.54867 23.7869C10.1654 23.7869 13.0973 20.8681 13.0973 17.2675C13.0973 13.667 10.1654 10.7482 6.54867 10.7482C2.93194 10.7482 0 13.667 0 17.2675C0 20.8681 2.93194 23.7869 6.54867 23.7869Z"
        fill="#FBB25B"
      />
      <path
        d="M9.02703 9.69285C11.7157 9.69285 13.8953 7.52303 13.8953 4.84642C13.8953 2.16982 11.7157 0 9.02703 0C6.33839 0 4.15881 2.16982 4.15881 4.84642C4.15881 7.52303 6.33839 9.69285 9.02703 9.69285Z"
        fill="#74AFDF"
      />
      <path
        d="M23.1841 10.3105C24.8957 10.3105 26.2832 8.92918 26.2832 7.22525C26.2832 5.52132 24.8957 4.14001 23.1841 4.14001C21.4725 4.14001 20.085 5.52132 20.085 7.22525C20.085 8.92918 21.4725 10.3105 23.1841 10.3105Z"
        fill="#393839"
      />
      <path
        d="M13.1859 17.2677C13.1706 17.7721 13.1113 18.2742 13.0085 18.7683C11.2005 18.3298 9.59153 17.3024 8.43717 15.8493C7.28281 14.3963 6.64927 12.6009 6.63721 10.7484C10.1754 10.6601 13.1859 13.6571 13.1859 17.2677Z"
        fill="#EF4625"
      />
      <path
        d="M13.9164 4.84488C13.9053 6.13045 13.386 7.35993 12.4708 8.26703C11.5557 9.17413 10.3185 9.68583 9.02709 9.69131C8.22106 9.70394 7.42782 9.48976 6.73865 9.07342C7.04807 7.44597 7.84749 5.95073 9.03074 4.78629C10.214 3.62185 11.7251 2.84332 13.3633 2.55408C13.7232 3.26481 13.9125 4.04897 13.9164 4.84488Z"
        fill="#6C4255"
      />
      <path
        d="M23.2051 10.3108C22.3869 10.2999 21.6054 9.97121 21.0273 9.39484C20.4491 8.81848 20.12 8.04005 20.1102 7.22556C20.1076 6.83416 20.1845 6.44628 20.3361 6.08516C20.4878 5.72403 20.711 5.39709 20.9926 5.1239C22.3208 6.53942 23.1044 8.37635 23.2051 10.3108Z"
        fill="#371716"
      />
      <path
        d="M44.4303 10.6549C44.4303 13.9167 42.4881 15.8334 39.7859 15.8334C39.2112 15.8622 38.6376 15.758 38.1101 15.529C37.5827 15.3 37.1157 14.9524 36.7459 14.5136V18.906H34.2548V5.74124H36.5896V7.04848C36.9436 6.53159 37.426 6.11475 37.9898 5.83853C38.5536 5.56231 39.1796 5.43611 39.807 5.47223C42.4881 5.47223 44.4303 7.39315 44.4303 10.6549ZM41.897 10.6549C41.897 8.86851 40.8583 7.7126 39.275 7.7126C37.6916 7.7126 36.6361 8.88112 36.6361 10.6549C36.6361 12.4287 37.6748 13.5972 39.275 13.5972C40.8752 13.5972 41.8885 12.4581 41.8885 10.6549H41.897Z"
        fill="#333333"
      />
      <path d="M46.2291 2.13489H48.7371V15.5855H46.2291V2.13489Z" fill="#333333" />
      <path
        d="M59.9007 5.74133V15.5645H57.5658V14.1101C57.1436 15.1652 55.9276 15.8335 54.6102 15.8335C52.2965 15.8335 50.9285 14.3792 50.9285 12.2649V5.74133H53.4365V11.6512C53.4365 12.8407 54.2809 13.5301 55.4209 13.5301C56.5609 13.5301 57.4054 12.8407 57.4054 11.6512V5.74133H59.9007Z"
        fill="#333333"
      />
      <path
        d="M61.3909 13.4754L63.6244 12.1892C63.8204 12.6475 64.1483 13.0378 64.5669 13.3109C64.9854 13.5839 65.4758 13.7275 65.9762 13.7234C67.0571 13.7234 67.4582 13.2274 67.4582 12.744C67.4582 12.2606 67.1922 12.0547 66.3055 11.8613L64.8953 11.5461C62.4506 11.0374 61.6569 10.0202 61.6569 8.60373C61.6569 6.9224 63.1178 5.45544 65.7609 5.45544C68.1886 5.45544 69.4638 6.74166 69.9029 7.70002L67.7242 8.92738C67.5279 8.52559 67.2207 8.18771 66.8387 7.95325C66.4566 7.71879 66.0154 7.59742 65.5666 7.60334C64.604 7.60334 64.1987 8.04469 64.1987 8.50705C64.1987 8.96942 64.5449 9.23423 65.4906 9.4486L66.9558 9.77225C69.3075 10.2893 70 11.2896 70 12.6683C70 14.4926 68.594 15.8923 65.8749 15.8923C63.5484 15.8713 62.0791 14.8583 61.3909 13.4754Z"
        fill="#333333"
      />
    </svg>
  );
};

export default OpPlusLogo;
